import _get from 'lodash/get'

/**
 * Map each list entry with get path
 * @param {Array} list
 * @param {string} path Path to get
 */
export default function mapGet(list, path) {
  if (Array.isArray(list)) {
    return list.map((entry) => _get(entry, path))
  }
  return []
}
